module.exports = __webpack_public_path__ + "img/sequence-miyashita-park.19c86274.jpg";